import smartStorage from "@/helpers/smart-storage";

/**
 * Clear the launch-email-creation sentinel (and its analytics source) from
 * storage. The sentinel drives the auto-open / partner handoff of the Create
 * email flow; it must be consumed once acted on so it doesn't persist across a
 * refresh (smartStorage is local/sessionStorage backed) and re-fire.
 */
export function clearLaunchEmailCreation(): void {
  smartStorage.removeItem("launchEmailCreation");
  smartStorage.removeItem("launchEmailCreationSource");
}
